
function IntegrationsListCtrl(TranslationService, IntegrationAdminService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    this.$onInit = function () {
        this.size = 22;
    };

    this.repair = function (integrationID) {
        console.log('repair' + integrationID);
    };

    this.edit = function (integrationID) {
        console.log('edit ' + integrationID);
        ctrl.onEdit({ id: integrationID })
    };

    this.editModal = function (item) {
        console.log('editModal');
        ctrl.onEditModal({ item: item });
    };

    this.getLastDate = function (item) {

    };

    this.editIntegrationGroups = function () {
        console.log('editIntegrationGroups');
    };

    this.toggleGroup = function (group) {
        //console.log('toggleGroup');
        //console.log(group1);
        group.IsCollapsed = !group.IsCollapsed;
        this.saveGroup(group);
    };

    this.saveGroup = function (group) {
        IntegrationAdminService.saveIntegrationGroup(group).then(function (response) {
            //$scope.integrationGroups = response.data;
            console.log('IntegrationGroupSalvo');
        }, function errorFunc(errorDescription) {
            console.log('erro salvar');
        });
    };
}

IntegrationsListCtrl.$inject = ['TranslationService', 'IntegrationAdminService'];

seedWebApp.component('integrationsList', {
    controller: IntegrationsListCtrl,
    bindings: {
        listItems: '<',
        filterString: '<',
        onEditModal: '&',
        onEdit: '&'
    },
    templateUrl: './SPA/integrations/integrationsList.html'
});